"use client";

import React from "react";

const getTrendColor = (trend, defaultColor = "") => {
  const isUp =
    trend === "up" || trend === "increased" || trend === 1 || trend === "1";
  const isDown =
    trend === "down" || trend === "decreased" || trend === 2 || trend === "2";
  if (isUp) return "text-green-500";
  if (isDown) return "text-red-500";
  return defaultColor;
};

const renderTrendArrow = (trend) => {
  const isUp =
    trend === "up" || trend === "increased" || trend === 1 || trend === "1";
  const isDown =
    trend === "down" || trend === "decreased" || trend === 2 || trend === "2";
  if (isUp)
    return (
      <span
        className="shrink-0 inline-block w-[10px] h-[10px] lu-odds-status--up ml-0.5"
        aria-hidden="true"
      />
    );
  if (isDown)
    return (
      <span
        className="shrink-0 inline-block w-[10px] h-[10px] lu-odds-status--down ml-0.5"
        aria-hidden="true"
      />
    );
  return null;
};

export default function CumeoOddsItem({
  leftOdds,
  leftTrend,
  middleValue,
  middleTrend,
  rightOdds,
  rightTrend,
  leftColor = "text-[var(--theme-highlight)]",
  middleColor = "text-[var(--theme-text-muted)]",
  rightColor = "text-[var(--theme-text)]",
  isHT = false,
  className = "",
}) {
  return (
    <div 
      className={`flex bg-[var(--theme-accent)] border border-solid border-[var(--theme-border)] rounded-sm shadow-[inset_-2px_-4px_4px_0px_rgba(0,0,0,0.25)] h-7 text-[12px] items-center m-0 p-0 box-border ${isHT ? "opacity-80" : ""} ${className}`}
    >
      <span className={`flex-1 flex items-center justify-center font-bold ${getTrendColor(leftTrend, leftColor)} m-0 p-0`}>
        {leftOdds || "-"}
        {renderTrendArrow(leftTrend)}
      </span>
      <span className={`flex-1 flex items-center justify-center ${getTrendColor(middleTrend, middleColor)} font-bold m-0 p-0`}>
        {middleValue || "-"}
        {renderTrendArrow(middleTrend)}
      </span>
      <span className={`flex-1 flex items-center justify-center font-bold ${getTrendColor(rightTrend, rightColor)} m-0 p-0`}>
        {rightOdds || "-"}
        {renderTrendArrow(rightTrend)}
      </span>
    </div>
  );
}
